import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

import UserImportForm from "./UserImportForm";
import { buildImportOverviewPath, IMPORT_TABS } from "./importNavigation";

export default function UserImportDetail() {
  const { id } = useParams();
  const location = useLocation();

  const backTo = useMemo(() => {
    const params = new URLSearchParams(location.search);
    if (!params.get("tab")) {
      params.set("tab", IMPORT_TABS.loginUsers);
    }
    return buildImportOverviewPath(params.toString());
  }, [location.search]);

  return (
    <div className="col-lg col-md-9 section-col-right d-flex">
      <div className="bg-white w-100 p-4 content-card">
        <UserImportForm id={id} backTo={backTo} />
      </div>
    </div>
  );
}
